<app-alert
  *ngFor="let alert of alerts"
  [type]="alert.type"
  [message]="alert.message"
  (close)="removeAlert(alert)"
></app-alert>
